// extracted by mini-css-extract-plugin
export default {"svgChartContainer":"ChartWrapper_svgChartContainer__QoptT"};